import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// Registers the interceptor that turns API failures into typed errors.
import '@/api/client';

import { Providers } from './app/providers';
import { router } from './app/router';

const container = document.getElementById('root');
if (!container) {
  throw new Error('No #root element found in index.html.');
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
